type LatLng = {
  lat: number;
  lng: number;
};

type TravelMode = "driving" | "walking" | "bicycling" | "transit";

/**
 * Generates a Google Maps direction URL between two points.
 *
 * @param origin - The starting point { lat, lng }
 * @param destination - The destination point { lat, lng }
 * @param travelMode - Optional mode of travel, default is 'driving'
 * @returns A URL string you can open in a new tab or use in a <a> tag
 */
export function getGoogleMapsDirectionUrl(
  origin: LatLng,
  destination: LatLng,
  travelMode: TravelMode = "driving",
): string {
  return `https://www.google.com/maps/dir/?api=1&origin=${origin.lat},${origin.lng}&destination=${destination.lat},${destination.lng}&travelmode=${travelMode}`;
}

export const getMarkerSVG = (
  type: "Pin" | "Star" | undefined,
  fillColor: string,
) => {
  if (type === "Pin") {
    return `
<svg xmlns="http://www.w3.org/2000/svg" width="17" height="24" viewBox="0 0 17 24" fill="none">
  <path d="M15.366 4.11C13.909 1.596 11.32 0.061 8.441 0.002C8.319 -0.001 8.195 -0.001 8.072 0.002C5.193 0.061 2.604 1.596 1.147 4.11C-0.343 6.679 -0.384 9.765 1.038 12.366L6.993 23.259C6.996 23.264 6.998 23.268 7.001 23.273C7.263 23.728 7.733 24 8.257 24C8.781 24 9.25 23.728 9.512 23.273C9.515 23.268 9.518 23.264 9.52 23.259L15.476 12.366C16.897 9.765 16.856 6.679 15.366 4.11Z" fill="white"/>
  <path d="M14.741 4.491C13.412 2.162 11.051 0.739 8.425 0.684C8.313 0.682 8.2 0.682 8.088 0.684C5.463 0.739 3.101 2.162 1.772 4.491C0.413 6.871 0.376 9.731 1.673 12.14L7.104 22.234C7.107 22.238 7.109 22.243 7.112 22.247C7.351 22.669 7.8 23.57 8.278 23.57C8.756 23.57 9.163 22.669 9.402 22.247C9.404 22.243 9.407 22.238 9.409 22.234L14.841 12.14C16.137 9.731 16.1 6.871 14.741 4.491Z" fill="${fillColor}"/>
  <polygon fill="white" points="9.214 14 9.214 10.196 13 10.196 13 7.786 9.214 7.786 9.214 4 6.786 4 6.786 7.786 3 7.786 3 10.196 6.786 10.196 6.786 14"/>
</svg>`;
  }

  if (type === "Star") {
    return `
<svg xmlns="http://www.w3.org/2000/svg" width="17" height="24" viewBox="0 0 17 24" fill="none">
  <path d="M15.366 4.11C13.909 1.596 11.32 0.061 8.441 0.002C8.319 -0.001 8.195 -0.001 8.072 0.002C5.193 0.061 2.604 1.596 1.147 4.11C-0.343 6.679 -0.384 9.765 1.038 12.366L6.993 23.259C6.996 23.264 6.998 23.268 7.001 23.273C7.263 23.728 7.733 24 8.257 24C8.781 24 9.25 23.728 9.512 23.273C9.515 23.268 9.518 23.264 9.52 23.259L15.476 12.366C16.897 9.765 16.856 6.679 15.366 4.11Z" fill="white"/>
  <path d="M14.741 4.491C13.412 2.162 11.051 0.739 8.425 0.684C8.313 0.682 8.2 0.682 8.088 0.684C5.463 0.739 3.101 2.162 1.772 4.491C0.413 6.871 0.376 9.731 1.673 12.14L7.104 22.234C7.107 22.238 7.109 22.243 7.112 22.247C7.351 22.669 7.8 23.57 8.278 23.57C8.756 23.57 9.163 22.669 9.402 22.247C9.404 22.243 9.407 22.238 9.409 22.234L14.841 12.14C16.137 9.731 16.1 6.871 14.741 4.491Z" fill="${fillColor}"/>
  <polygon fill="white" points="8 13.29 4.91 15 5.5 11.38 3 8.82 6.45 8.29 8 5 9.55 8.29 13 8.82 10.5 11.38 11.09 15"/>
</svg>`;
  }

  // Default marker = Google default pin
  return null;
};
